import InvoiceList from './InvoiceList';
import InvoiceShow from './InvoiceShow';
import ReceiptIcon from '@material-ui/icons/Receipt';

export default {
  list: InvoiceList,
  show: InvoiceShow,
  icon: ReceiptIcon,
};
